import { render, staticRenderFns } from "./plusRightMoveList.vue?vue&type=template&id=7f4b0ed1&"
import script from "./plusRightMoveList.vue?vue&type=script&lang=js&"
export * from "./plusRightMoveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "plusRightMoveList.vue"
export default component.exports